/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'classnames';
import { ROUTES } from '@/constants';
import type { OfertaTrabajo } from '@/interfaces/strapi';
import { generatePath, useNavigate } from 'react-router-dom';
import CTNButton from '@ctn/ui/components/ctn-button';
import { useCallback } from 'react';

type JobOfferListItemProps = {
	readonly className?: string;
	readonly jobOffer: OfertaTrabajo;
};

const classNameComponent = 'c-cnm-job-offer-card';

export const InfoRow = ({ label, children }: { readonly label: string; readonly children: React.ReactNode }) => (
	<div className={`${classNameComponent}__body-text`}>
		<span>{label}</span>
		<p>{children}</p>
	</div>
);

export const JobOfferListItem = ({ className, jobOffer }: JobOfferListItemProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	const navigate = useNavigate();

	const redirectTo = useCallback(() => {
		const path = generatePath(ROUTES.SERVICIOS_PORTAL_EMPLEO_BY_OFERTA, { oferta: String(jobOffer.id) });
		navigate(path);
	}, [navigate, jobOffer.id]);

	const {
		ref,
		titulo,
		funciones,
		descripcion,
		lugar,
		duracionContrato,
		horario,
		incorporacion,
		requisitos_form,
		requisitos_exp,
		requisitos_otros,
	} = jobOffer;

	const rows: Array<{ value?: string | null; label: string }> = [
		{ value: descripcion, label: 'Descripción del puesto:' },
		{ value: funciones, label: 'Funciones:' },
		{ value: lugar, label: 'Lugar de trabajo:' },
		{ value: duracionContrato, label: 'Duración / contrato:' },
		{ value: horario, label: 'Horario:' },
		{ value: incorporacion, label: 'Incorporación:' },
		{ value: requisitos_form, label: 'Requisitos formación:' },
		{ value: requisitos_exp, label: 'Requisitos experiencia:' },
		{ value: requisitos_otros, label: 'Otros Requisitos:' },
	];

	return (
		<article className={wrapperClassName}>
			<div className={`${classNameComponent}__header`}>
				<div className={`${classNameComponent}__header-text`}>
					<span>Ref.: {ref}</span>
					<h5>{titulo}</h5>
				</div>
				<CTNButton
					type="button"
					variant="solid"
					mode="primary"
					className={`${classNameComponent}__btn`}
					label="Contactar"
					onClick={redirectTo}
				/>
			</div>

			<div className={`${classNameComponent}__body`}>
				{rows.map(
					(row) =>
						row.value && (
							<InfoRow key={row.label} label={row.label}>
								{row.value}
							</InfoRow>
						),
				)}
			</div>
		</article>
	);
};
